<template>
  <div>
    <br />
    <h5 class="pageTitle" style="text-align:center">
      Le Grand 24 heures du COQ
    </h5>
    <br /><br />
    <img src="/images/24h_160px.png" style="float:right" alt="" />
    <p>
      L'objectif de cette activité est de recenser un maximum d'espèces d'oiseaux sur le territoire du COQ en 24 heures. La stratégie consiste à explorer divers habitats et secteurs à travers le territoire, <strong>de 17&nbsp;h le vendredi à 17&nbsp;h le samedi. En 2024, le défi aura lieu du vendredi 25&nbsp;mai au samedi 26&nbsp;mai</strong>. La participation est ouverte à tous, que l’on soit débutant ou expert, et elle est gratuite.
    </p>

    <p>
    Participer est simple! Il suffit d’indiquer dans ce <a href="https://forms.gle/9Xp3EGN8qovfG2ib9" target="_blank">formulaire</a> la zone que vous prévoyez visiter. Les listes d’observations devront être soumises sur eBird. Vous pourrez ensuite envoyer vos listes à la personne coordinatrice ainsi que partager de belles photos ou des anecdotes. Merci d'inclure votre nom et votre adresse courriel dans le formulaire afin que nous puissions vous contacter pour fournir des informations plus détaillées.
    </p>
    <p>Les résultats seront présentés lors d'une réunion à la mi-juin au Domaine de Maizerets pour récapituler les observations.</p>
    <p>
      La coordonnatrice du 24 Heures du COQ,<br />
      <a href="mailto:ccasabona@coq.qc.ca">Clara Casabona</a>
    </p>

    <br /><br />
    <h2 class="pageSubtitle2">Au total, 266 espèces observées depuis 1997</h2>
    <table style="width:30%">
      <tr>
        <td>
          <a href="/documents/24h/ListeCumulative24H2017.pdf"></a
          ><img src="/images/icone_pdf.png" alt="" />
        </td>
        <td>
          <a href="/documents/24h/listeCumulative24H.pdf">Liste cumulative</a>
        </td>
      </tr>
    </table>

    <br /><br /><br />
    <h2 class="pageSubtitle2">
      Listes des espèces observées et comptes-rendus
    </h2>
    <br /><br />

    <!-- Exemple de colonne non remplie :
                    <td width="10%"><p class="Annee">2018</p></td>
                    <td width="2%"><img src="/images/icone_pdf.png" alt="" /></td>
                    <td width="17%"><p>Liste</p></td>
                    <td><p>Compte-rendu</p></td>
         -->

    <table id="Table_comptes-rendus" style="width:90%" align="center">
      <tr>
        <!-- <td width="10%"><p class="Annee" style="color:#E08934">2019</p></td>
              <td width="2%"><img src="/images/icone_pdf.png" alt="" /></td>
              <td width="17%"><p><a href="/documents/24h/24Heures2019.pdf">Liste 186 esp.</a></p></td>
              <td><p><a href="pages_24h/compte_rendu2016.html">Compte-rendu</a></p></td> -->
        <td width="10%"><p class="Annee" style="color:#E08934">2024</p></td>
        <td width="2%"></td>
        <td width="17%">
          <p>
            <a href="/documents/24h/CR-24h-COQ-2024.pdf">Compte rendu</a>
          </p>
        </td>
        <td><p></p></td>
        <td width="10%"><p class="Annee" style="color:#E08934">&nbsp;</p></td>
        <td width="2%"></td>
        <td width="17%"><p>&nbsp;</p></td>
        <td><p></p></td>
      </tr>
      
      <tr>
        <!-- <td width="10%"><p class="Annee" style="color:#E08934">2019</p></td>
              <td width="2%"><img src="/images/icone_pdf.png" alt="" /></td>
              <td width="17%"><p><a href="/documents/24h/24Heures2019.pdf">Liste 186 esp.</a></p></td>
              <td><p><a href="pages_24h/compte_rendu2016.html">Compte-rendu</a></p></td> -->
        <td width="10%"><p class="Annee" style="color:#E08934">2023</p></td>
        <td width="2%"></td>
        <td width="17%">
          <p>
            <a href="/documents/24h/CR-24h-COQ-2023.pdf">Compte rendu</a>
          </p>
        </td>
        <td><p></p></td>
        <td width="10%"><p class="Annee" style="color:#E08934">2022</p></td>
        <td width="2%"></td>
        <td width="17%"><p><a href="/documents/24h/CR-24h-COQ-2022.pdf">Compte rendu</a></p></td>
        <td><p></p></td>
      </tr>

      <tr>
        <!-- <td width="10%"><p class="Annee" style="color:#E08934">2019</p></td>
              <td width="2%"><img src="/images/icone_pdf.png" alt="" /></td>
              <td width="17%"><p><a href="/documents/24h/24Heures2019.pdf">Liste 186 esp.</a></p></td>
              <td><p><a href="pages_24h/compte_rendu2016.html">Compte-rendu</a></p></td> -->
        <td width="10%"><p class="Annee" style="color:#E08934">2020-2021</p></td>
        <td width="2%"></td>
        <td width="17%" colspan=5>
          <p>
          Le Grand 24 Heures du COQ n'a pas pu avoir lieu en raison de la pandémie de la COVID.
          </p>
        </td>
      </tr>
      <tr>
        <!-- <td width="10%"><p class="Annee" style="color:#E08934">2019</p></td>
              <td width="2%"><img src="/images/icone_pdf.png" alt="" /></td>
              <td width="17%"><p><a href="/documents/24h/24Heures2019.pdf">Liste 186 esp.</a></p></td>
              <td><p><a href="pages_24h/compte_rendu2016.html">Compte-rendu</a></p></td> -->
        <td width="10%"><p class="Annee" style="color:#E08934">2019</p></td>
        <td width="2%"></td>
        <td width="17%">
          <p>
            <router-link
              :to="{ name: 'Grand24SinglePage', params: { year: 2019 } }"
              >Compte rendu</router-link
            >
          </p>
        </td>
        <td><p></p></td>
        <td width="10%"><p class="Annee" style="color:#E08934"></p></td>
        <td width="2%"></td>
        <td width="17%"><p></p></td>
        <td><p></p></td>
      </tr>
      <tr>
        <!-- <td width="10%"><p class="Annee" style="color:#E08934">2018</p></td>
              <td width="2%"><img src="/images/icone_pdf.png" alt="" /></td>
              <td width="17%"><p><a href="/documents/24h/24Heures2016.pdf">Liste 186 esp.</a></p></td>
              <td><p><a href="pages_24h/compte_rendu2016.html">Compte-rendu</a></p></td> -->
        <td width="10%"><p class="Annee" style="color:#E08934">2018</p></td>
        <td width="2%">
          <a href="/documents/24h/24Heures2017.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td width="17%">
          <p><a href="/documents/24h/24Heures2018.pdf">Liste 198 esp.</a></p>
        </td>
        <td>
          <p>
            <router-link
              :to="{ name: 'Grand24SinglePage', params: { year: 2018 } }"
              >Compte rendu</router-link
            >
          </p>
        </td>
        <td width="10%"><p class="Annee" style="color:#E08934">2017</p></td>
        <td width="2%">
          <a href="/documents/24h/24Heures2017.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td width="17%">
          <p><a href="/documents/24h/24Heures2017.pdf">Liste 194 esp.</a></p>
        </td>
        <td>
          <p>
            <router-link
              :to="{ name: 'Grand24SinglePage', params: { year: 2017 } }"
              >Compte rendu</router-link
            >
          </p>
        </td>
      </tr>
      <tr>
        <td width="10%"><p class="Annee" style="color:#E08934">2016</p></td>
        <td width="2%"><img src="/images/icone_pdf.png" alt="" /></td>
        <td width="17%">
          <p><a href="/documents/24h/24Heures2016.pdf">Liste 186 esp.</a></p>
        </td>
        <td>
          <p>
            <router-link
              :to="{ name: 'Grand24SinglePage', params: { year: 2016 } }"
              >Compte rendu</router-link
            >
          </p>
        </td>
        <td width="10%"><p class="Annee" style="color:#E08934">2015</p></td>
        <td width="2%">
          <a href="/documents/24h/24Heures2013.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td width="17%">
          <p>
            <a href="/documents/viree_2015/viree2015_especes_par_site.pdf"
              >Liste par site</a
            >
          </p>
        </td>
        <td>
          <p>
            Voir la
            <router-link :to="{ name: 'Page60eme' }">Virée 2015</router-link>
          </p>
        </td>
      </tr>
      <tr>
        <td width="10%"><p class="Annee" style="color:#E08934">2014</p></td>
        <td width="2%">
          <a href="/documents/24h/24Heures2014.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td width="17%">
          <p><a href="/documents/24h/24Heures2014.pdf">Liste 193 esp.</a></p>
        </td>
        <td>
          <p>
            <router-link
              :to="{ name: 'Grand24SinglePage', params: { year: 2014 } }"
              >Compte rendu</router-link
            >
          </p>
        </td>
        <td width="10%"><p class="Annee" style="color:#E08934">2013</p></td>
        <td width="2%">
          <a href="/documents/24h/24Heures2013.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td width="17%">
          <p><a href="/documents/24h/24Heures2013.pdf">Liste 190 esp.</a></p>
        </td>
        <td>
          <p>
            <router-link
              :to="{ name: 'Grand24SinglePage', params: { year: 2013 } }"
              >Compte rendu</router-link
            >
          </p>
        </td>
      </tr>
      <tr>
        <td><p class="Annee" style="color:#E08934">2012</p></td>
        <td>
          <a href="/documents/24h/24Heures2012.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td>
          <p><a href="/documents/24h/24Heures2012.pdf">Liste 193 esp.</a></p>
        </td>
        <td>
          <p>
            <router-link
              :to="{ name: 'Grand24SinglePage', params: { year: 2012 } }"
              >Compte rendu</router-link
            >
          </p>
        </td>
        <td><p class="Annee" style="color:#E08934">2011</p></td>
        <td>
          <a href="/documents/24h/24Heures2011.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td>
          <p><a href="/documents/24h/24Heures2011.pdf">Liste 174 esp.</a></p>
        </td>
        <td>
          <p>
            <router-link
              :to="{ name: 'Grand24SinglePage', params: { year: 2011 } }"
              >Compte rendu</router-link
            >
          </p>
        </td>
      </tr>
      <tr>
        <td><p class="Annee" style="color:#E08934">2010</p></td>
        <td>
          <a href="/documents/24h/24Heures2010.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td>
          <p><a href="/documents/24h/24Heures2010.pdf">Liste 187 esp.</a></p>
        </td>
        <td>
          <p>
            <router-link
              :to="{ name: 'Grand24SinglePage', params: { year: 2010 } }"
              >Compte rendu</router-link
            >
          </p>
        </td>
        <td><p class="Annee" style="color:#E08934">2009</p></td>
        <td>
          <a href="/documents/24h/24Heures2009.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td>
          <p><a href="/documents/24h/24Heures2009.pdf">Liste 202 esp.</a></p>
        </td>
        <td>
          <p>
            <router-link
              :to="{ name: 'Grand24SinglePage', params: { year: 2009 } }"
              >Compte rendu</router-link
            >
          </p>
        </td>
      </tr>
      <tr>
        <td><p class="Annee" style="color:#E08934">2008</p></td>
        <td>
          <a href="/documents/24h/24Heures2008.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td>
          <p><a href="/documents/24h/24Heures2008.pdf">Liste 179 esp.</a></p>
        </td>
        <td>
          <p>
            <router-link
              :to="{ name: 'Grand24SinglePage', params: { year: 2008 } }"
              >Compte rendu</router-link
            >
          </p>
        </td>
        <td><p class="Annee" style="color:#E08934">2007</p></td>
        <td>
          <a href="/documents/24h/24Heures2007.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td>
          <p><a href="/documents/24h/24Heures2007.pdf">Liste 206 esp.</a></p>
        </td>
        <td>
          <p>
            <router-link
              :to="{ name: 'Grand24SinglePage', params: { year: 2007 } }"
              >Compte rendu</router-link
            >
          </p>
        </td>
      </tr>
      <tr>
        <td><p class="Annee" style="color:#E08934">2006</p></td>
        <td>
          <a href="/documents/24h/24Heures2006.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td>
          <p><a href="/documents/24h/24Heures2006.pdf">Liste 193 esp.</a></p>
        </td>
        <td>
          <p>
            <router-link
              :to="{ name: 'Grand24SinglePage', params: { year: 2006 } }"
              >Compte rendu</router-link
            >
          </p>
        </td>
        <td><p class="Annee" style="color:#E08934">2005</p></td>
        <td>
          <a href="/documents/24h/25Heures2005.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td>
          <p><a href="/documents/24h/25Heures2005.pdf">Liste 201 esp.</a></p>
        </td>
        <td>
          <p>
            <router-link
              :to="{ name: 'Grand24SinglePage', params: { year: 2005 } }"
              >Compte rendu</router-link
            >
          </p>
        </td>
      </tr>
      <tr>
        <td><p class="Annee" style="color:#E08934">2004</p></td>
        <td>
          <a href="/documents/24h/24Heures2004.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td>
          <p><a href="/documents/24h/24Heures2004.pdf">Liste 199 esp.</a></p>
        </td>
        <td>
          <p>
            <router-link
              :to="{ name: 'Grand24SinglePage', params: { year: 2004 } }"
              >Compte rendu</router-link
            >
          </p>
        </td>
        <td><p class="Annee" style="color:#E08934">2003</p></td>
        <td>
          <a href="/documents/24h/24Heures2003.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td>
          <p><a href="/documents/24h/24Heures2003.pdf">Liste 175 esp.</a></p>
        </td>
        <td><p>&nbsp;</p></td>
      </tr>
      <tr>
        <td><p class="Annee" style="color:#E08934">2002</p></td>
        <td>
          <a href="/documents/24h/24Heures2002.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td>
          <p><a href="/documents/24h/24Heures2002.pdf">Liste 203 esp.</a></p>
        </td>
        <td><p>&nbsp;</p></td>
        <td><p class="Annee" style="color:#E08934">2001</p></td>
        <td>
          <a href="/documents/24h/24Heures2001.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td>
          <p><a href="/documents/24h/24Heures2001.pdf">Liste 184 esp.</a></p>
        </td>
        <td><p>&nbsp;</p></td>
      </tr>
      <tr>
        <td><p class="Annee" style="color:#E08934">2000</p></td>
        <td>
          <a href="/documents/24h/24Heures2000.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td>
          <p><a href="/documents/24h/24Heures2000.pdf">Liste 200 esp.</a></p>
        </td>
        <td><p>&nbsp;</p></td>
        <td><p class="Annee" style="color:#E08934">1999</p></td>
        <td>
          <a href="/documents/24h/24Heures1999.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td>
          <p><a href="/documents/24h/24Heures1999.pdf">Liste 199 esp.</a></p>
        </td>
        <td><p>&nbsp;</p></td>
      </tr>
      <tr>
        <td><p class="Annee" style="color:#E08934">1998</p></td>
        <td>
          <a href="/documents/24h/24Heures1998.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td>
          <p><a href="/documents/24h/24Heures1998.pdf">Liste 185 esp.</a></p>
        </td>
        <td><p>&nbsp;</p></td>
        <td><p class="Annee" style="color:#E08934">1997</p></td>
        <td>
          <a href="/documents/24h/24Heures1997.pdf"
            ><img src="/images/icone_pdf.png" alt=""
          /></a>
        </td>
        <td>
          <p><a href="/documents/24h/24Heures1997.pdf">Liste 194 esp.</a></p>
        </td>
        <td><p>&nbsp;</p></td>
      </tr>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'grand24'
  };
</script>

<style scoped></style>
